<template lang='pug' src='./hero-blog.pug'></template>

<script>

export default {
  computed: {
    propstitle () {
      return this.$store.state.pages['blog']
    }
  },
  data () {
    return {
      array: ''
    }
  },
  props: ['props'],
  created () {
    this.getArray()
  },
  updated () {
    this.getArray()
  },
  components: {

  },
  methods: {
    getArray () {
      this.$router.options.routes.filter(parent => {
        if (parent.path === this.$route.path) {
          this.array = parent.children
        }
        if (parent.path === this.$route.meta) {
          parent.children.filter(child => {
            if (child.name === this.$route.name) {
              this.array = child.grandchildren
            }
          })
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// hero-blog.vue?20ffadf7